import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Directory, Filesystem } from '@capacitor/filesystem';
import { ModalController, ToastController } from '@ionic/angular';
import { SchemeEditorService } from 'src/app/services/scheme-editor.service';

@Component({
  selector: 'app-secure-scheme-editor-modal',
  templateUrl: './scheme-editor-modal.component.html'
})
export class SchemeEditorModalComponent implements OnInit {
  fileUploadForm: FormGroup = new FormGroup({});
  modalHeader: string;
  fileType: string;
  base64: string | ArrayBuffer;
  selectedFile: File;
  isSubmitDisabled: boolean = false;

  maskMobileNumber: string;
  key: string;
  isOtpVerify: boolean;

  loginOtp: string;

  isResendOtpButtonVisible: boolean = false;
  resendOtpIn: any = null;
  timerOn = true;

  constructor(private modalCtrl: ModalController, private toastController: ToastController,

    private schemeEditorService: SchemeEditorService,
  ) { }

  ngOnInit(): void {

    this.fileUploadForm = new FormGroup({
      reason: new FormControl(null, [
        Validators.required,
        Validators.maxLength(200),
      ]),
      file: new FormControl(null, [
        Validators.required
      ]),
    });

    this.onLoad();

  }

  onLoad() {
    this.schemeEditorService
    .sendOtp(+this.key)
    .subscribe((data: any) => {
      console.log(data);
      if (data.status === "SUCCESS") {
        this.isOtpVerify = true;
        this.maskMobileNumber = data.maskMobileNumber; 
        this.resendOtpTimer(120);
        // this.openModal();
      } else {
        return this.schemeEditorService.errorToast(data.errorMessage);
      }
    });
  }

  async showErrorToast(errorMessage: string) {
    const toast = await this.toastController.create({
      message: errorMessage,
      icon: "information-circle",
      position: "top",
      duration: 2000,
    });
    toast.present();
  }

  upload() {
    if (!this.selectedFile) {
      this.showErrorToast("Please Upload the File.");
    }

    if (!this.base64) {
      this.showErrorToast("Please Upload the File.");
    }
    
    if (!this.fileUploadForm.value.reason) {
      this.showErrorToast("Please enter reason.");
    }

    // console.log("on Submit works", this.key, "   ",this.fileUploadForm.value.reason);

    if (this.base64 && this.fileUploadForm.value.reason) {
      return this.modalCtrl.dismiss({base64: this.base64,reason: this.fileUploadForm.value.reason}, "submit" );
    }
    else {
      this.showErrorToast("Please enter reason and upload file.");
    }
  }

  onFileSelect(event) {
    this.isSubmitDisabled = true;
    this.selectedFile = event.target.files[0];
    console.log("Selected File in Modal >>>>> ", this.selectedFile);

    if (this.selectedFile?.name.endsWith('.pdf') || this.selectedFile?.name.endsWith('.PDF')) {
      const reader = new FileReader();
      reader.readAsDataURL(this.selectedFile);
      reader.onload = () => {
        this.base64 = reader.result;
        this.isSubmitDisabled = false;
      }
    } else {
      this.showErrorToast("Please Upload the image File.");
    }

  }

  verifyOtp() {
    console.log("verify otp works", this.key, "  ", this.loginOtp);

    if (this.loginOtp != null && this.loginOtp.length > 0) {
      this.schemeEditorService
        .verifyOtp(this.key, this.loginOtp)
        .subscribe((data: any) => {
          console.log(data);
          if (data.status === "SUCCESS") {
            // this.isOtpVerify = false;
            return this.modalCtrl.dismiss('OTP_VERIFY', "submit" );
          } else {
            return this.schemeEditorService.errorToast(data.errorMessage);
          }
        });
    } else {
      return this.schemeEditorService.errorToast("Please enter otp");
    }

  }

  cancel() {
    return this.modalCtrl.dismiss(null, 'cancel');
  }

  public space(event: any) {
    if (event.target.selectionStart === 0 && event.code === 'Space') {
      event.preventDefault();
    }
  }

  onSubmit() {

    console.log("on Submit works", this.key, "   ",this.fileUploadForm.value.reason);

    if(!this.fileUploadForm.value.reason) {
      return;
    }
    if(this.base64 != null) {
      return;
    }
    
  }

  numberOnly(event: any) {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  onResendOtpClick() {
    this.isResendOtpButtonVisible = false;
    this.onLoad();
    // this.schemeEditorService
    //   .sendOtp(+this.key)
    //   .subscribe((data: any) => {
    //     console.log(data);
    //     if (data.status === "SUCCESS") {
    //       this.maskMobileNumber = data.maskMobileNumber;
    //     } else {
    //       return this.schemeEditorService.errorToast(data.errorMessage);
    //     }
    //   });
  }

  resendOtpTimer(remaining: any) {
    var m: any = Math.floor(remaining / 60);
    var s: any = remaining % 60;

    m = m < 10 ? "0" + m : m;
    s = s < 10 ? "0" + s : s;
    this.resendOtpIn = m + ":" + s;
    localStorage.setItem("otpResendTimeLeft", this.resendOtpIn);
    remaining -= 1;

    if (remaining >= 0 && this.timerOn) {
      setTimeout(() => {
        this.resendOtpTimer(remaining);
      }, 1000);
      return;
    }

    if (!this.timerOn) {
      // Do validate stuff here
      return;
    } else {
      // Do timeout stuff here
      // alert('Timeout for otp');
      this.isResendOtpButtonVisible = true;
    }
  }

}
